import { Routes } from '@angular/router';
import { ShellLocalize } from './i18n';
import { environment } from '@env/environment';

export const appRoutes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: `/${environment.defaultLanguage}`,
    },
    {
        path: '',
        children: ShellLocalize.rootRoutes([
            {
                path: '',
                loadChildren: () => import('./main-page/main-page.routes').then((m) => m.MAIN_PAGE_ROUTES),
                data: { title: 'main-page' },
            },
            {
                path: 'products',
                loadChildren: () => import('./products/products.routes').then((m) => m.PRODUCTS_ROUTES),
                data: { title: 'products' },
            },
            {
                path: 'about-us',
                loadChildren: () => import('./about-us/about-us.routes').then((m) => m.ABOUT_US_ROUTES),
                data: { title: 'about-us' },
            },
            {
                path: 'our-services',
                loadChildren: () => import('./our-services/our-services.routes').then((m) => m.OUR_SERVICES_ROUTES),
                data: { title: 'our-services' },
            },
            {
                path: 'our-showroom',
                loadChildren: () => import('./our-showroom/our-showroom.routes').then((m) => m.OUR_SHOWROOM_ROUTES),
                data: { title: 'our-showroom' },
            },
            {
                path: 'partners',
                loadChildren: () => import('./partners/partners.routes').then((m) => m.PARTNERS_ROUTES),
                data: { title: 'partners' },
            },
            {
                path: 'configurator',
                loadChildren: () => import('./configurator/configurator.routes').then((m) => m.CONFIGURATOR_ROUTES),
                data: { title: 'configurator' },
            },
            {
                path: 'eu-projects',
                loadChildren: () => import('./eu-projects/eu-projects.routes').then((m) => m.EU_PROJECTS_ROUTES),
                data: { title: 'eu-projects' },
            },
            {
                path: 'legal',
                loadChildren: () => import('./legal/legal.routes').then((m) => m.LEGAL_ROUTES),
                data: { title: 'legal' },
            },
            {
                path: 'not-found',
                loadChildren: () => import('./not-found/not-found.routes').then((m) => m.NOT_FOUND_ROUTES),
                data: { title: 'not-found' },
            },
            {
                path: 'certificates',
                loadChildren: () => import('./certificates/certificates.routes').then((m) => m.CERTIFICATES_ROUTES),
                data: { title: 'certificates' },
            },
            {
                path: 'complaints',
                loadChildren: () => import('./complaints/complaints.routes').then((m) => m.COMPLAINTS_ROUTES),
                data: { title: 'complaints' },
            },
            {
                path: 'partner-salons',
                loadChildren: () => import('./partner-salons/partner-salons.routes').then((m) => m.PARTNER_SALONS_ROUTES),
                data: { title: 'partner-salons' },
            },
            {
                // Unknown URL under a valid language prefix (e.g. /pl/garbage) -> render the
                // localized not-found page in place. NotFoundComponent sets a real 404 on SSR.
                path: '**',
                loadChildren: () => import('./not-found/not-found.routes').then((m) => m.NOT_FOUND_ROUTES),
                data: { title: 'not-found' },
            },
        ]),
    },
    {
        // URL with no/invalid language prefix (e.g. /garbage) -> normalize to the default
        // language, preserving the attempted path so it lands on the not-found wildcard above.
        path: '**',
        redirectTo: (redirectData) => `/${environment.defaultLanguage}/${redirectData.url.map((segment) => segment.path).join('/')}`,
    },
];
